import { render, staticRenderFns } from "./DialogSetting.vue?vue&type=template&id=0dafb93c"
import script from "./DialogSetting.vue?vue&type=script&lang=js"
export * from "./DialogSetting.vue?vue&type=script&lang=js"
import style0 from "./DialogSetting.vue?vue&type=style&index=0&id=0dafb93c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports